export default __webpack_public_path__ + "5a85b9703ce19a1ccb7efc41f61ba203.png";